module.exports = __webpack_public_path__ + "static/media/7sinif.yt.mat.3.4f5ab40a.jpg";